import React, { ChangeEvent } from "react";
import { Value } from './core/Value';
import Common from "./Common";

export default class DynamicInput extends React.Component<DynamicInput.Props, DynamicInput.State>
{

    value: Value
    ref: React.RefObject<HTMLInputElement>;
    prevValue: string;
    selection: number;

    constructor(props: DynamicInput.Props)
    {
        super(props);

        this.ref = React.createRef();
        this.value = Value.getNumber(props.id);

        this.state = {};
        
        this.prevValue = this.value.strValue;
        this.selection = this.value.strValue.length;
    }


    componentDidMount(): void
    {
        this.value.register(this.onValueUpdate, this)
        this.onValueUpdate();
    }
    
    
    componentWillUnmount(): void
    {
        this.value.unregister(this.onValueUpdate, this)
    }


    componentDidUpdate(): void
    {
        if (this.ref.current)
        {
            this.ref.current.selectionStart = this.selection;
            this.ref.current.selectionEnd = this.selection;
        }
    }


    onValueUpdate()
    {
        if (this.props.forcedValue != null)
        {
            this.ref.current.value = this.props.forcedValue;
        }
        else if (this.value.ignoreDecimals)
        {
            this.ref.current.value = Common.formatCurrency(this.value.value.toString(), true);
        }
        else
        {
            this.ref.current.value = Common.formatCurrency(this.value.strValue);
        }
        
    }


    onChange(event: ChangeEvent<HTMLInputElement>)
    {
        const native = event.nativeEvent as InputEvent;
        
        let val = event.currentTarget.value.replaceAll(/[^,.0-9]/g, () => "");
        
        this.selection = event.target.selectionStart;

        if (native.inputType === "insertText")
        {
            if (",.".includes(native.data))
            {
                if (
                    this.prevValue.includes(".") ||
                    this.prevValue[this.selection - 2] == "," || 
                    this.prevValue[this.selection - 1] == ","
                )
                {
                    this.selection--;

                    this.ref.current.value = this.prevValue;
                    this.ref.current.selectionStart = this.selection;
                    this.ref.current.selectionEnd = this.selection;
                    
                    if (this.props.onChange)
                    {
                        this.props.onChange();
                    }

                    return;
                }
                else
                {
                    val = val.substring(0, this.selection - 1) + "." + val.substring(this.selection);
                }
            }
            else if ((/[^0-9]/).test(native.data))
            {
                this.selection--;

                this.ref.current.value = this.prevValue;
                this.ref.current.selectionStart = this.selection;
                this.ref.current.selectionEnd = this.selection;
                
                if (this.props.onChange)
                {
                    this.props.onChange();
                }

                return;
            }
        }
        else
        {
            val = [
                val.substring(0, val.indexOf(".") + 1), 
                val.substring(val.indexOf(".")).replaceAll(".", "")
            ].filter((v,i) => v?.length).join("");

            if (this.selection == 0 && val.length)
            {
                this.selection = val.length;
            }
        }

        this.ref.current.value = val;
        this.ref.current.selectionStart = this.selection;
        this.ref.current.selectionEnd = this.selection;

        this.prevValue = val;

        if (this.props.onChange)
        {
            this.props.onChange();
        }
    }


    onBlur()
    {
        this.value.setValue(this.ref.current.value.replaceAll(",", ""));
        this.onValueUpdate();
    }


    render()
    {
        return (
            <input
                ref={this.ref}
                type="text"
                className={this.props.className}
                onChange={this.props.forcedValue != null ? undefined : this.onChange.bind(this)}
                onBlur={this.props.forcedValue != null ? undefined : this.onBlur.bind(this)}
                placeholder={this.props.placeholder}
                disabled={this.props.forcedValue != null}
            />
        );
    }


    shouldComponentUpdate()
    {
        return false;
    }


}


export namespace DynamicInput
{


    export interface Props
    {
        id: ValueId;
        className?: string;
        onChange?: () => void;
        placeholder?: string;
        forcedValue?: string;
    }


    export interface State
    {
        
    }


}